import React from "react";
import { useUser } from "@clerk/clerk-react";
import useApi from "../../../shared/hooks/useApi";
import Button from "../../../shared/components/FormElements/Button";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon, TrashIcon } from "@heroicons/react/16/solid";

export default function CancelSubscription() {
	const { user } = useUser();
	const { data: portalUrl, loading } = useApi(
		user?.id && user?.publicMetadata?.customerId
			? `/api/billing/customer-portal/${user.id}/${user.publicMetadata.customerId}`
			: null,
	);

	return (
		<div className="mt-8">
			<p className="text-sm text-red-800 flex items-center gap-1">
				<TrashIcon className="size-4" />
				Abonnement opzeggen? Dat kun je{" "}
				<Link
					to={portalUrl || "#"}
					target="_blank"
					className="underline font-semibold flex items-center"
				>
					hier doen
					<ArrowUpRightIcon className="size-4" />
				</Link>{" "}
			</p>
		</div>
	);
}
